<template>
  <div id="user">
    <p class="title"><label @click="$router.push('/user/home')">我的 / </label>订单
      汇总金额：{{amountTotal}}
    </p>
    <div class="common-search-box">
      <div>
        <div>
          <span class="common-search-label">订单状态</span>
          <el-select v-model="query.orderStatus" size="small">
            <el-option value label="全部"></el-option>
            <el-option v-for="(item, i) in statusList" :key="i" :value="i+''" :label="item"></el-option>
          </el-select>
        </div>
        <div>
          <span class="common-search-label">日期选择</span>
          <el-date-picker
            v-model="query.searchTime"
            format="yyyy-MM-dd"
            type="daterange"
            size="small"
            style="width: 240px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeQueryTime"
          ></el-date-picker>
        </div>
      </div>
      <div>
        <el-input placeholder="订单号、商品名称"  v-model="query.key" size="small" style="width: 200px"></el-input>
        <button class="common-btn sureBtn-1" @click="getOrderQuery">查询</button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="订单号" min-width="2"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="订单名" min-width="4">
          <template slot-scope="scope">
            {{scope.row.name ? scope.row.name : scope.row.orderName}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" min-width="3"></el-table-column>
        <el-table-column prop="money" label="金额（元）" min-width="2"></el-table-column>
        <el-table-column prop="consignee" label="收货人" min-width="2"></el-table-column>
        <el-table-column prop="orderStatus" label="状态" min-width="2">
          <template slot-scope="scope">
              <el-tag type="success" class="imm" v-if="scope.row.orderStatus < 0">主账号审核</el-tag>
              <el-tag v-else class="imm" :class="'state' + scope.row.orderStatus">{{statusList[scope.row.orderStatus]}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" min-width="4">
          <template slot-scope="scope">
            <button class="common-btn" slot="reference"
                    v-if="scope.row.status == 1 && scope.row.orderStatus == 2"
                    @click="doConfirm(scope.row)">提交</button>
            <el-popconfirm
              v-if="scope.row.status == 9 && scope.row.orderStatus == 2"
              title="确认订单无误？（确认后发货）"
              @confirm="doConfirm(scope.row)"
            >
              <el-button class="common-btn" slot="reference">确认</el-button>
            </el-popconfirm>
            <el-button
              class="common-btn sureBtn-2"
              @click="$router.push('/order/orderDetail?id='+scope.row.id)"
            >详情</el-button>
            <el-popconfirm v-if="scope.row.orderStatus < 3" title="确认取消订单？" @confirm="cancel(scope.row.id)">
              <button class="common-btn cancel" slot="reference">取消</button>
            </el-popconfirm>
            <button class="common-btn" @click="reBuy(scope.row.id)" v-if="scope.row.orderStatus >= 5">再次购买</button>
          </template>
        </el-table-column>
      </el-table>

        <div style="display: flex">
            <span style="flex-grow: 1;text-align:right;padding-right: 20px;padding-top: 22px;">
            汇总金额： {{amountTotal}}
            </span>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import { orderList, submission, cancelOrder } from "@/js/api";
import {
  orderStatusList
} from "@/js/goods"
export default {
  name: "orderlist",
  computed: {
      amountTotal() {
          var amount = 0.00
          this.tableData.map ( item  => {
              if (item.money) {
                  amount += item.money
              }
          })
          return amount.toFixed(2)
      }
  },
  data() {
    return {
      query: {
        key: '',
        pageNo: 0,
        pageSize: 10,
        orderStatus: this.$route.query.orderStatus || "",
        createTime: "",
        endTime: "",
        searchTime: []
      },
      total: 0,
      statusList: orderStatusList,
      // statusList: [
      //   "结束",
      //   "用户编辑",
      //   "业务员整理",
      //   "供应商确认",
      //   "业务员确认",
      //   "业务员推荐类似",
      //   "用户付款",
      //   "领导审批",
      //   "用户确认",
      //   "用户已确认",
      //   "已发货"
      // ],
      tableData: []
    };
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getOrder();
    },
    handleCurrentChange(e) {
      this.query.pageNo = e;
      this.getOrder();
    },
    getOrder() {
      orderList({
        ...this.query,
        state: 0 // 未删除
      }).then(res => {
        if (res.code == 200 && res.result) {
          const list = (res.result && res.result.records) || [];
          this.total = res.result.total || 0;
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getOrderQuery(){
      this.query.pageNo = 0
      this.getOrder()
    },
    changeQueryTime(e) {
      if (!e) {
        this.query.createTime = "";
        this.query.endTime = "";
        return;
      }
      this.query.createTime = this.formatTime(e[0]) + " 00:00:00";
      this.query.endTime = this.formatTime(e[1]) + " 23:59:59";
    },
    formatTime(time) {
      return `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`;
    },
    doConfirm(item) {
      console.log('item', item)
      submission({
        orderId: item.id,
        confirm: 0
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getOrder();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    reBuy(id) {
      this.$router.push(`/order/create?orderId=${id}`);
    },
    cancel(id) {
      cancelOrder({
        id: id
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.getOrder();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>
